import styled from "styled-components"

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 91vh;
  overflow-y: auto;
  align-items: center;
  max-width: 420px;
  width: 90vw;
  margin: 0 auto;
  background: radial-gradient(ellipse at top, #5e2d8e 0%, #3a1259 60%, #2a0e42 100%);
  padding: 35px 0 18px;
  color: #fff;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5), 0 0 40px rgba(94, 45, 142, 0.3);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(200, 160, 255, 0.2);

  h3 {
    font-size: 1.4rem;
    margin: 0 0 20px;
    font-weight: bold;
  }

`

export const ThanksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 420px;
`

export const FormWrapper = styled.div`
  display: flex;
  max-width: 420px;
  padding-top: 0 !important;
  padding: 0 15px;
`

export const StyledScrollingDiv = styled.div`
  flex: 1;
  margin-bottom: 12px;
  padding: 0 15px;
`

export const ScrollWrapper = styled.div`
  height: 100%;
  flex: 1;
  margin-bottom: 12px;
`

export const QuitButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 2px solid rgba(200, 160, 255, 0.2);
  border-radius: 50%;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.2s ease, background 0.2s ease, border-color 0.2s ease;
  z-index: 1;
  backdrop-filter: blur(4px);

  &:hover {
    opacity: 0.9;
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(200, 160, 255, 0.35);
  }
`

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 6px;
`

export const StyledHeading = styled.h3`
  font-family: "Rammetto One", cursive;
  margin-bottom: 20px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  color: #fff;
`

export const Subtitle = styled.p`
  font-size: 1rem;
  color: #fff;
  margin: 0 20px 14px;
  line-height: 1.4;

  strong {
    color: #E839B2;
    font-weight: 700;
  }
`

export const ThanksText = styled.p`
  font-size: 16px;
`

export const ModernInput = styled.input`
  font-size: 1rem;
  color: #fff;
  border-radius: 14px;
  padding: 14px 18px;
  background-color: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.15);
  width: 100%;
  outline: none;
  transition: all 0.25s ease;
  box-sizing: border-box;
  backdrop-filter: blur(4px);

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
    font-weight: 400;
  }

  &:focus {
    border-color: #E839B2;
    background-color: rgba(255, 255, 255, 0.18);
    box-shadow: 0 0 0 3px rgba(232, 57, 178, 0.15);
  }
`

export const UserTypeSelector = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .title {
    font-family: "Rammetto One";
    margin: 0 0 2px;
    opacity: 0.5;
    font-size: 0.8rem;
  }
`

export const UserTypeCards = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`

export const UserTypeCard = styled.div<{ selected: boolean }>`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 8px;
  gap: 12px;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.25s ease;
  background: ${({ selected }) =>
    selected ? "rgba(255, 255, 255, 0.18)" : "rgba(255, 255, 255, 0.06)"};
  border: 2px solid
    ${({ selected }) =>
    selected ? "#E839B2" : "rgba(255, 255, 255, 0.12)"};
  backdrop-filter: blur(4px);
  box-shadow: ${({ selected }) =>
    selected ? "0 0 12px rgba(232, 57, 178, 0.2)" : "none"};

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: ${({ selected }) =>
    selected ? "#E839B2" : "rgba(255, 255, 255, 0.3)"};
  }

  .icon {
    font-size: 1.5em;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .label {
    font-size: .7em;
    font-weight: 600;
    color: #fff;
    letter-spacing: 0.02em;
  }
`

export const SubmitButton = styled.button<{ disabled?: boolean }>`
  width: calc(100% - 40px);
  padding: 12px 24px;
  margin: 4px 20px 6px;
  border-radius: 16px;
  border: none;
  background: ${({ disabled }) =>
    disabled
      ? "rgba(255, 255, 255, 0.15)"
      : "linear-gradient(135deg, #E839B2 0%, #E839B2 100%)"};
  color: ${({ disabled }) => (disabled ? "rgba(255,255,255,0.5)" : "#fff")};
  font-size: 1.1rem;
  font-weight: normal;
  font-family: "Rammetto One", cursive;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: all 0.25s ease;
  box-shadow: ${({ disabled }) =>
    disabled ? "none" : "0 6px 20px rgba(232, 57, 178, 0.4)"};
  letter-spacing: 0.02em;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #F062C5 0%, #E839B2 100%);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(232, 57, 178, 0.5);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 4px 12px rgba(232, 57, 178, 0.4);
  }
`

export const Permission = styled.p`
  font-size: 11px;
  opacity: 0.7;
`

export const InboxMessage = styled.div`
  display: flex;
  flex-direction: column;
  .icon {
    font-size: 1.5rem;
  }

  font-size: 0.8rem;
  margin-bottom: 12px;
  padding: 0 20px;

  > .text {
    color: #fff;
  }
`

export const OfferBadge = styled.span`
  display: inline-block;
  font-family: "Rammetto One", cursive;
  background: linear-gradient(90deg, #E839B2 0%, #E839B2 100%);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 6px 18px;
  border-radius: 20px;
  margin-bottom: 14px;
`

export const OfferImage = styled.img`
  width: 180px;
  max-width: 80%;
  margin-bottom: 8px;
`

export const OfferDiscount = styled.div`
  font-family: "Rammetto One", cursive;
  font-size: 2.1rem;
  color: #fff;
  line-height: 1;
  margin-bottom: 6px;
  text-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
`

export const OfferPlanName = styled.div`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 600;
  letter-spacing: 0.05em;
  margin-bottom: 14px;
`

export const OfferDescription = styled.p`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
  margin: 0 0 18px;
  text-align: center;

  em {
    position: relative;
    color: #F78DD7;
    font-weight: bold;
    font-style: normal;
  }

  svg, img {
    vertical-align: middle;
  }
`

export const PriceCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 16px 24px;
  gap: 24px;
  backdrop-filter: blur(4px);
  margin-bottom: 8px;
`

export const PriceDivider = styled.div`
  width: 1px;
  height: 50px;
  background: rgba(255, 255, 255, 0.15);
`

export const PriceSide = styled.div<{ highlight?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  .label {
    font-size: 0.9rem;
    font-family: 'Rammetto One', cursive;
    letter-spacing: 0.1em;
    color: ${({ highlight }) =>
    highlight ? "#E839B2" : "rgba(255, 255, 255, 0.35)"};
  }

  .price {
    font-family: "Rammetto One", cursive;
    font-size: ${({ highlight }) => (highlight ? "1.8rem" : "1.3rem")};
    color: ${({ highlight }) =>
    highlight ? "#E839B2" : "rgba(255, 255, 255, 0.35)"};
    line-height: 1;
  }

  .striked {
    text-decoration: line-through;
  }
`

export const OfferExpiry = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.55);
  margin-top: 6px;

  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #4caf50;
    box-shadow: 0 0 6px rgba(76, 175, 80, 0.6);
  }
`

export const SkipLink = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.25);
  font-size: 0.8rem;
  cursor: pointer;
  padding: 8px 16px;
  transition: color 0.2s ease;

  &:hover {
    color: rgba(255, 255, 255, 0.7);
  }
`

export const Keypoints = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Keypoint = styled.div`
  display: flex;
  align-items: center;
  width: 180px;

  > .label {
    text-align: center;
    font: normal normal normal 14px/18px Rammetto One;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
    margin-left: 8px;
  }
`
